import { CareerPathways } from '~/components/main-page/CareerPathways'
import { IndexFaqBlock } from '~/components/main-page/IndexFaqBlock'
import { FeatureVideos } from '~/components/main-page/FeatureVideos'
import { Hero } from '~/components/main-page/Hero'
import { TailoredSolutions } from '~/components/main-page/TailoredSolutions'
import { MainSlider } from '~/components/main-page/MainSlider'
import { Advantages } from '~/components/main-page/Advantages'
import { FindNewJob } from '~/components/main-page/FindNewJob'
import { ResumeBuilder } from '~/components/main-page/ResumeBuilder'
import { ResumeTemplates } from '~/components/main-page/ResumeTemplates'
import { CoverLetter } from '~/components/main-page/CoverLetter'
import { Instruments } from '~/components/main-page/Instruments'
import { SimulateInterview } from '~/components/main-page/SimulateInterview'
import { ExcelInMyCareer } from '~/components/main-page/ExcelInMyCareer'
import { NavigateYourCareer } from '~/components/main-page/NavigateYourCareer'
import { CareerTransition } from '~/components/main-page/CareerTransition'
import { CardsList } from '~/components/main-page/CardsList'
import { GetEdge } from '~/components/main-page/GetEdge'
import { Banner as TotalJobSearchBanner } from '~/components/main-page/TotalJobSearchBanner/Banner'
import CareerAdvice from './CareerAdvice'
import ResumeExamplesSlider from './ResumeExamplesSlider'
import { TopLevelBlock } from '@contentful/rich-text-types'
import { Asset } from 'contentful'

type PageConstructorProps = {
  sections: TopLevelBlock[]
  banner: {
    titleText?: string | undefined
    bodyText?: string | undefined
    ctaButtonText?: string | undefined
    ctaButtonBackground?: string | undefined
    ctaButtonLink?: string | undefined
    image?: Asset<'WITHOUT_UNRESOLVABLE_LINKS', string> | undefined
    backgroundColour?: string | undefined
  }
}

export const PageConstructor = ({ sections, banner }: PageConstructorProps) => {
  const cleanBlocksList = sections
    .filter((block) => block.nodeType === 'embedded-entry-block')
    .map((item) => item.data.target)
    .map((section, index: number) => {
      switch (section.fields.blockId) {
        case 'faq_block':
          return <IndexFaqBlock faqData={section} key={index} />
        case 'features_videos':
          return <FeatureVideos entry={section} key={index} />
        case 'home_main_slider':
          return <MainSlider section={section} key={index} />
        case 'home_hero_with_video':
          return <Hero section={section} key={index} />
        case 'home_tailored_solutions':
          return <TailoredSolutions section={section} key={index} />
        case 'home_highlight_points':
          return <ResumeBuilder section={section} key={index} />
        case 'home_cards_list':
          return <CardsList section={section} key={index} />
        case 'home_three_cards_list':
          return <Instruments section={section} key={index} />
        case 'home_advantages':
          return <Advantages section={section} key={index} />
        case 'home_land_next_job':
          return <FindNewJob section={section} key={index} />
        case 'home_resume_examples_slider':
          return <ResumeExamplesSlider section={section} key={index} />
        case 'home_take_advice':
          return <CareerAdvice section={section} key={index} />
        case 'home_resume_templates':
          return <ResumeTemplates section={section} key={index} />
        case 'home_create_cover':
          return <CoverLetter section={section} key={index} />
        case 'home_simulating_interview_prep':
          return <SimulateInterview section={section} key={index} />
        case 'home_plan_your_promotion':
          return <ExcelInMyCareer section={section} key={index} />
        case 'home_career_coaching':
          return <NavigateYourCareer section={section} key={index} />
        case 'home_career_transition':
          return <CareerTransition section={section} key={index} />
        case 'home_plan_your_new_career':
          return <CareerPathways section={section} key={index} />
        case 'home_get_edge':
          return <GetEdge section={section} key={index} />
        default:
          return undefined
      }
    })

  const [first, ...rest] = cleanBlocksList
  const blocks = [
    first,
    <TotalJobSearchBanner fields={banner} key={'total_job_search_banner'} />,
    ...rest,
  ]
  return <div>{blocks}</div>
}
